import React from 'react';
import {
  ToggleButtonGroup as Group,
  SxProps,
  ToggleButton,
} from '@mui/material';
import { Option } from '@client/new/helpers/types';
import { bgColorsVars } from '@design-system/vars.css';
import { clsx } from 'clsx';

type ToggleButtonGroupProps<T> = {
  value: T;
  onChange: (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    value: T,
  ) => void;
  options: Option<T>[];
  toStringValue: (v: T) => string;
  toValue: (v: string) => T;
  groupSx?: SxProps;
  buttonSx?: SxProps;
  newStyle?: boolean;
};

const newButtonStyle = {
  minWidth: '72px',
  padding: '8px 16px',
  color: 'black',
  '&.Mui-selected': {
    color: bgColorsVars['P-80'],
    background: bgColorsVars['P-20'],
  },
  '&:hover': {
    color: '#2C3548',
  },
};

const buttonStyle = {
  minWidth: '72px',
  padding: '4px 8px',
  border: 'solid 1px #2C3548',
  color: '#2C3548',
  '&.Mui-selected': {
    color: 'white',
    background: '#2C3548',
  },
  '&:hover': {
    color: '#2C3548',
  },
};

const groupStyle = {
  borderRadius: '6px',
};

export const ToggleButtonGroup = <T,>({
  value,
  onChange,
  options,
  newStyle,
  ...p
}: ToggleButtonGroupProps<T>) => (
  <Group
    color="primary"
    value={value}
    exclusive
    onChange={(e, s) => s && onChange(e, p.toValue(s))}
    sx={{
      ...(newStyle ? {} : groupStyle),
      ...(p?.groupSx || {}),
    }}
  >
    {options.map(({ label, value }) => (
      <ToggleButton
        data-testid="toggleButtonGroup"
        value={p.toStringValue(value)}
        key={p.toStringValue(value)}
        sx={{
          ...(newStyle ? newButtonStyle : buttonStyle),
          ...(p?.buttonSx || {}),
        }}
        className={clsx(newStyle && 'rounded-[10px]')}
      >
        {label}
      </ToggleButton>
    ))}
  </Group>
);
